import { useAuth } from '@AuthProvider';
import { useAuth as useClerkAuth } from '@clerk/react';
import SplashLoader from '@components/atoms/SplashLoader';
import { Navigate, Outlet } from 'react-router-dom';
import { isClerkAuthEnabled } from 'src/utils/clerkAuth';

interface PropertyGuardRouteProps {
  predicate: () => boolean;
  redirectTo?: string;
}

const ClerkPropertyGuardRoute: React.FC<PropertyGuardRouteProps> = ({ predicate, redirectTo = '/auth' }) => {
  const { isLoaded, isSignedIn } = useClerkAuth();

  if (!isLoaded) return <SplashLoader />;
  if (!isSignedIn || !predicate()) return <Navigate to={redirectTo} replace />;

  return <Outlet />;
};

const OutsetaPropertyGuardRoute: React.FC<PropertyGuardRouteProps> = ({ predicate, redirectTo = '/auth' }) => {
  const { isLoading } = useAuth();

  if (isLoading) return null;
  if (!predicate()) return <Navigate to={redirectTo} replace />;

  return <Outlet />;
};

export const PropertyGuardRoute: React.FC<PropertyGuardRouteProps> = (props) =>
  isClerkAuthEnabled() ? <ClerkPropertyGuardRoute {...props} /> : <OutsetaPropertyGuardRoute {...props} />;
